import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=67e078c4&scoped=true"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js"
import style0 from "./RegisterSuccess.vue?vue&type=style&index=0&id=67e078c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e078c4",
  null
  
)

export default component.exports